import { Component, Input, OnDestroy } from '@angular/core';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import * as StrategyActions from '@strategy/strategy.actions';

@Component({
  selector: 'app-strategy-tabs',
  templateUrl: './strategy-tabs.component.html',
  styleUrls: ['./strategy-tabs.component.scss'],
  standalone: false
})
export class StrategyTabsComponent implements OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  @Input() step: number;
  @Input() tabSelected: number;
  @Input() highestTabIndex: number;
  @Input() is3aPillar: boolean;
  @Input() strategyWasChanged: { modalOpened: boolean; redirectUrl: string; strategyWasChanged: boolean };

  constructor(private store: Store) {}

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  tabNavigation(tabIndex: number): void {
    if (this.strategyWasChanged.strategyWasChanged) {
      this.store.dispatch(StrategyActions.setStrategyWasChanged({ modalOpened: true, redirectUrl: `tabs/${tabIndex}`, strategyWasChanged: true }));
    } else {
      this.store.dispatch(StrategyActions.setTabIndex({ tabIndex }));
    }
  }

  getTabIcon(tab: number, is3aPillar = false): string {
    if (this.step !== 1) {
      return `icon-i-checkmark-circle`;
    }
    if (this.highestTabIndex > tab) {
      return `icon-i-checkmark-circle`;
    }
    return `icon-i-step-${is3aPillar ? tab - 1 : tab}`;
  }
}
